import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  BooleanInput,
  DateField,
  Edit,
  EditProps,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { IksorisParkingTicketCashMachineDto } from '../../../../core/dto/device/ticket-machines/iksoris-parking-ticket-cash-machine/iksoris-parking-ticket-cash-machine.dto'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import FilteredReferenceInput from '../../../common/FilteredReferenceInput'
import { ResourceName } from '../../../../core/ResourceName'

const validateIksorisParkingTicketCashMachineEdit = (
  values: IksorisParkingTicketCashMachineDto,
) => {
  const errors: { [n: string]: string } = {}
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  if (!values.address) {
    errors.address = 'ra.validation.required'
  }
  return errors
}

const EditTitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate(
        'resources.iksoris-parking-ticket-cash-machines.titles.create',
      )}
    </span>
  )
}

const EditToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ShowButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const IksorisParkingTicketCashMachineEdit = (props: EditProps) => {
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const hasAuthority = useHasAuthority()

  return (
    <Edit {...props} title={<EditTitle />}>
      <SimpleForm
        redirect="show"
        validate={validateIksorisParkingTicketCashMachineEdit}
        toolbar={<EditToolbar />}
      >
        <TextInput source="name" isRequired />
        <BooleanInput source="isWatched" />
        <DateField
          source="lastRefresh"
          showTime
          options={{
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }}
        />
        {hasAuthority(Authority.VIEW_DEVICE_CATEGORIES) && (
          <FilteredReferenceInput
            source="categoryId"
            defaultValue={null}
            reference={ResourceName.DEVICE_CATEGORIES}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={smallScreen ? 5 : 15}
            allowEmpty
            filterSource="search"
            selectWithPaginationInputProps={{
              optionText: 'hierarchyString',
              showFilter: true,
            }}
          />
        )}
        {hasAuthority(Authority.VIEW_CAMERAS) && (
          <FilteredReferenceInput
            source="cameraId"
            defaultValue={null}
            reference={ResourceName.CAMERAS}
            sort={{ field: 'description', order: 'ASC' }}
            perPage={smallScreen ? 5 : 15}
            allowEmpty
            filterSource="search"
            selectWithPaginationInputProps={{
              optionText: 'description',
              showFilter: true,
            }}
          />
        )}
        <TextInput source="address" isRequired />
        <TextInput source="automatAPIAddress" />
      </SimpleForm>
    </Edit>
  )
}
